// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3ealY","empty":"ModalGraph_empty__1iZGo"};